// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e2f89e90","511":"f93eeda1","767":"82ba2e4d"}[chunkId] + ".chunk.js";
};